<template>
    <div class="carddesign card h-100">
        <div class="card-header" v-html="$strings('main.tiles.PersonalTutor.title')"></div>
        <div class="card-body">
            <p class="card-text" v-html="$strings('main.tiles.PersonalTutor.description')"></p>
            <router-link class="btn btn-primary"
                :to="{ name: $strings('main.tiles.PersonalTutor.link') }">{{ $strings('main.tiles.PersonalTutor.linkTitle') }}&nbsp;<i class="bi bi-arrow-right"></i></router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PersonalTutorTile',
        methods: {}
    };

</script>

<style scoped>
</style>
